import {aiSearchMockRes} from '../../../_legacy/Searches/components/AISearch/constants';
import {getBaseURL, getPostRequestOptions} from '../utils';

type AIFilterPayload = {
    formName: string;
    query: string;
    columns: {name: string; title: string; type: string; possibleValues?: string[]}[];
};

export type AISuggestedFilter = {
    column: string;
    operator: string;
    values: string[];
};

export const getAISuggestedFilters = async (
    params: AIFilterPayload
): Promise<{
    filters?: Array<AISuggestedFilter>;
    code?: number;
    message?: string;
}> => {
    const returnTestResponse =
        new URLSearchParams(window.location.search).get('_ai_search_test') === '1';

    if (returnTestResponse) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(aiSearchMockRes);
            }, 1000);
        });
    }

    return fetch(`${getBaseURL()}/llm-services/getFilters`, getPostRequestOptions(params))
        .then(res => {
            return res.json();
        })
        .then(data => data);
};
